import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const HorizontalBaseline = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="2.5" y1="13.5" x2="17.5" y2="13.5" stroke={color} fill="none" strokeLinecap="round" />
    <rect x="5.5" y="4.5" width="9" height="12" rx="1.5" stroke={color} fill="none" />
    <path d="M10 8.5L10 12" stroke={color} fill="none" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default HorizontalBaseline;
